<template>
  <div class="index-page">

    <index-hero-section
      :fields="indexPageSections.sections.index_hero_section.fields"
    />

    <index-about-section
      :fields="indexPageSections.sections.index_about_section.fields"
    />

    <index-features2-section
      :fields="indexPageSections.sections.index_features_2_section.fields"
    />

    <index-divider-section
      :fields="indexPageSections.sections.index_divider_section.fields"
    />

    <index-cover-section
      :fields="indexPageSections.sections.index_cover_section.fields"
    />

    <index-text-section
      :fields="indexPageSections.sections.index_text_section.fields"
    />

    <index-features-section
      :fields="indexPageSections.sections.index_features_section.fields"
    />

    <index-divider2-section
      :fields="indexPageSections.sections.index_divider2_section.fields"
    />

    <index-text2-section
      :fields="indexPageSections.sections.index_text2_section.fields"
    />

    <index-call-to-action-section
      :fields="indexPageSections.sections.index_call_to_action_section.fields"
    />

  </div>
</template>

<script>

import IndexHeroSection from "/seu-frontend/sections/index-page/IndexHeroSection";
import IndexCoverSection from "/seu-frontend/sections/index-page/IndexCoverSection";
import IndexTextSection from "/seu-frontend/sections/index-page/IndexTextSection";
import IndexFeaturesSection from "/seu-frontend/sections/index-page/IndexFeaturesSection";
import IndexText2Section from "/seu-frontend/sections/index-page/IndexText2Section";
import IndexCallToActionSection from "/seu-frontend/sections/index-page/IndexCallToActionSection";
import IndexFeatures2Section from "/seu-frontend/sections/index-page/IndexFeatures2Section";
import IndexDividerSection from "/seu-frontend/sections/index-page/IndexDividerSection";
import IndexDivider2Section from "/seu-frontend/sections/index-page/IndexDivider2Section";
import IndexAboutSection from "/seu-frontend/sections/index-page/IndexAboutSection.vue";

export default {
  name: "IndexPage",
  components: {
    IndexAboutSection,
    IndexDivider2Section,
    IndexDividerSection,
    IndexFeatures2Section,
    IndexCallToActionSection,
    IndexText2Section,
    IndexFeaturesSection,
    IndexTextSection,
    IndexCoverSection,
    IndexHeroSection,
  },

  computed: {
    indexPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/indexPage`).default;
    }
  },

}
</script>

<style lang="scss">
@import "IndexPage";
</style>
